<dx-scroll-view class="agent-editor ag-editor">
  <ag-shr-agent-header
    [agentId]="selectedAgent[BaseModelKeys.dbId]"
    (onFieldsUpdated)="handleAgentFieldsChanges($event)"
  ></ag-shr-agent-header>

  <ng-template [ngIf]="detailsView === 'Agent'">
    <dx-tabs
      #editorTabs
      style="width: 70%"
      [items]="agentTabs | editorPermittedTabs | async"
      [selectedIndex]="selectedAgentIndex"
      (onItemClick)="selectAgentTab($event)"
      (onContentReady)="onContentReady($event)"
    >
      <div
        *dxTemplate="let item of 'templateCampaignsTab'"
        [class.campaigns-disabled]="!selectedAgent[AgentKeys.isActiveCampaigns]"
        (click)="onAllianceCampaignsClick($event)"
      >
        <i *ngIf="!selectedAgent[AgentKeys.isActiveCampaigns]" class="dx-icon-agi-lock"></i>
        Alliance Campaigns
      </div>
    </dx-tabs>

    <ng-template [ngIf]="selectedAgentTab === 'Contact Info'">
      <dx-scroll-view height="60%">
        <div class="row mt-2">
          <div class="col-6" *ngIf="Entity.agentContactInfoAddresses | hasPermission | async">
            <ag-shr-addresses-grid
              [gridTitle]="'Addresses'"
              class="addresses-grid--profile"
              [showPhysicalLocation]="false"
              [addresses]="selectedAgent?.addresses"
              [agentDbId]="selectedAgent?.dbId"
              [hasPermissionsToEdit]="
                Entity.agentContactInfoAddresses | hasPermission: EntityPermissionActivityKeys.write | async
              "
              [hasPermissionsToDelete]="
                Entity.agentContactInfoAddresses | hasPermission: EntityPermissionActivityKeys.delete | async
              "
              [hasPermissionsToAdd]="
                Entity.agentContactInfoAddresses | hasPermission: EntityPermissionActivityKeys.create | async
              "
              [updateAddress]="onSaveAddresses"
            ></ag-shr-addresses-grid>

            @if (Entity.agentContactInfoSocials | hasPermission | async) {
              <ag-shr-socials-grid
                class="ag-profile-grid--profile"
                [gridTitle]="'Socials'"
                [type]="LayoutGridType.shortExtended"
                [socials]="selectedAgent?.socials"
                [agentDbId]="selectedAgent?.dbId"
                [socialMediaLookup]="socialMediaLookup$ | async"
                [socialTypesLookup]="socialTypesLookup$ | async"
                [hasPermissionsToEdit]="
                  Entity.agentContactInfoSocials | hasPermission: EntityPermissionActivityKeys.write | async
                "
                [hasPermissionsToDelete]="
                  Entity.agentContactInfoSocials | hasPermission: EntityPermissionActivityKeys.delete | async
                "
                [hasPermissionsToAdd]="
                  Entity.agentContactInfoSocials | hasPermission: EntityPermissionActivityKeys.create | async
                "
                [saveSocials]="onSaveSocial"
              ></ag-shr-socials-grid>
            }
          </div>
          <div class="col-6">
            @if (Entity.agentContactInfoEmailAddresses | hasPermission | async) {
              <ag-shr-email-addresses
                [agentId]="selectedAgent?.dbId"
                [agentUID]="selectedAgent?.[AgentKeys.uid]"
                [type]="LayoutGridType.shortExtended"
                [canEdit]="
                  Entity.agentContactInfoEmailAddresses | hasPermission: EntityPermissionActivityKeys.write | async
                "
                [canDelete]="
                  Entity.agentContactInfoEmailAddresses | hasPermission: EntityPermissionActivityKeys.delete | async
                "
                [canCreate]="
                  Entity.agentContactInfoEmailAddresses | hasPermission: EntityPermissionActivityKeys.create | async
                "
              ></ag-shr-email-addresses>
            }

            @if (Entity.agentContactInfoPhoneNumbers | hasPermission | async) {
              <ag-shr-phone-numbers
                [agentId]="selectedAgent?.dbId"
                [phoneNumbers]="selectedAgent?.phone_numbers"
                [type]="LayoutGridType.shortExtended"
                (phoneNumbersChange)="selectedAgent.phone_numbers = $event"
                [canEdit]="
                  Entity.agentContactInfoPhoneNumbers | hasPermission: EntityPermissionActivityKeys.write | async
                "
                [canDelete]="
                  Entity.agentContactInfoPhoneNumbers | hasPermission: EntityPermissionActivityKeys.delete | async
                "
                [canCreate]="
                  Entity.agentContactInfoPhoneNumbers | hasPermission: EntityPermissionActivityKeys.create | async
                "
              ></ag-shr-phone-numbers>
            }

            @if (Entity.agentContactInfoWebsites | hasPermission | async) {
              <ag-shr-websites
                class="ag-profile-grid--profile"
                [gridTitle]="'Websites'"
                [type]="LayoutGridType.shortExtended"
                [parentDbId]="selectedAgent?.dbId"
                [websites]="selectedAgent?.websites"
                [websiteTypesLookup]="websiteTypesLookup$ | async"
                [saveWebsites]="onSaveWebsites"
                [hasPermissionsToEdit]="
                  Entity.agentContactInfoWebsites | hasPermission: EntityPermissionActivityKeys.write | async
                "
                [hasPermissionsToDelete]="
                  Entity.agentContactInfoWebsites | hasPermission: EntityPermissionActivityKeys.delete | async
                "
                [hasPermissionsToAdd]="
                  Entity.agentContactInfoWebsites | hasPermission: EntityPermissionActivityKeys.create | async
                "
              ></ag-shr-websites>
            }
          </div>
        </div>
      </dx-scroll-view>
    </ng-template>

    <ng-template [ngIf]="selectedAgentTab === 'Personal Info'">
      <dx-scroll-view height="60%">
        <div class="row mt-2">
          @if (Entity.agentPersonalInformation | hasPermission | async) {
            <div class="col-6">
              <ag-shr-personal-information
                [agent]="selectedAgent"
                [type]="LayoutGridType.shortExtended"
                (personalInformationChange)="handleAgentFieldsChanges($event)"
                [canEdit]="Entity.agentPersonalInformation | hasPermission: EntityPermissionActivityKeys.write | async"
                [canDelete]="
                  Entity.agentPersonalInformation | hasPermission: EntityPermissionActivityKeys.delete | async
                "
                [canCreate]="
                  Entity.agentPersonalInformation | hasPermission: EntityPermissionActivityKeys.create | async
                "
              ></ag-shr-personal-information>
            </div>
          }

          @if (Entity.agentPersonalInfoSizesForFunStuff | hasPermission | async) {
            <div class="col-6">
              <ag-shr-sizes
                [agent]="selectedAgent"
                [type]="LayoutGridType.shortExtended"
                [hasPermissionsToEdit]="
                  Entity.agentPersonalInfoSizesForFunStuff | hasPermission: EntityPermissionActivityKeys.write | async
                "
                [hasPermissionsToDelete]="
                  Entity.agentPersonalInfoSizesForFunStuff | hasPermission: EntityPermissionActivityKeys.delete | async
                "
                [hasPermissionsToAdd]="
                  Entity.agentPersonalInfoSizesForFunStuff | hasPermission: EntityPermissionActivityKeys.create | async
                "
              ></ag-shr-sizes>
            </div>
          }
        </div>

        @if (Entity.agentPersonalInfoAssociations | hasPermission | async) {
          <div class="row mt-2">
            <div class="col-12">
              <ag-shr-associations
                class="ag-profile-grid--profile"
                [agentId]="selectedAgent?.dbId"
                [type]="LayoutGridType.shortExtended"
                [hasPermissionsToEdit]="
                  Entity.agentPersonalInfoAssociations | hasPermission: EntityPermissionActivityKeys.write | async
                "
                [hasPermissionsToDelete]="
                  Entity.agentPersonalInfoAssociations | hasPermission: EntityPermissionActivityKeys.delete | async
                "
                [hasPermissionsToAdd]="
                  Entity.agentPersonalInfoAssociations | hasPermission: EntityPermissionActivityKeys.create | async
                "
              ></ag-shr-associations>
            </div>
          </div>
        }

        @if (Entity.agentPersonalInfoDietaryConsiderations | hasPermission | async) {
          <div class="row mt-2">
            <div class="col-12">
              <ag-shr-dietary-considerations
                [agent]="selectedAgent"
                [type]="LayoutGridType.shortExtended"
                (onFieldsUpdated)="handleAgentFieldsChanges($event)"
                [hasPermissionsToEdit]="
                  Entity.agentPersonalInfoDietaryConsiderations
                    | hasPermission: EntityPermissionActivityKeys.write
                    | async
                "
                [hasPermissionsToDelete]="
                  Entity.agentPersonalInfoDietaryConsiderations
                    | hasPermission: EntityPermissionActivityKeys.delete
                    | async
                "
                [hasPermissionsToAdd]="
                  Entity.agentPersonalInfoDietaryConsiderations
                    | hasPermission: EntityPermissionActivityKeys.create
                    | async
                "
              ></ag-shr-dietary-considerations>
            </div>
          </div>
        }

        @if (Entity.agentPersonalInfoFlightPreferences | hasPermission | async) {
          <div class="row mt-2">
            <div class="col-12">
              <ag-shr-flight-preferences
                [agent]="selectedAgent"
                [type]="LayoutGridType.shortExtended"
                (onFieldsUpdated)="handleAgentFieldsChanges($event)"
                [canEdit]="
                  Entity.agentPersonalInfoFlightPreferences | hasPermission: EntityPermissionActivityKeys.write | async
                "
                [canDelete]="
                  Entity.agentPersonalInfoFlightPreferences | hasPermission: EntityPermissionActivityKeys.delete | async
                "
                [canCreate]="
                  Entity.agentPersonalInfoFlightPreferences | hasPermission: EntityPermissionActivityKeys.create | async
                "
              ></ag-shr-flight-preferences>
            </div>
          </div>
        }
      </dx-scroll-view>
    </ng-template>

    <ng-template [ngIf]="selectedAgentTab === 'Agent Info'">
      <dx-scroll-view height="60%">
        <div class="row mt-2">
          <div class="col-6" *ngIf="Entity.agentAgentInfoAgentPortal | hasPermission | async">
            <ag-shr-portal
              [canEdit]="Entity.agentAgentInfoAgentPortal | hasPermission: EntityPermissionActivityKeys.write | async"
              [canDelete]="
                Entity.agentAgentInfoAgentPortal | hasPermission: EntityPermissionActivityKeys.delete | async
              "
              [canCreate]="
                Entity.agentAgentInfoAgentPortal | hasPermission: EntityPermissionActivityKeys.create | async
              "
              [agent]="selectedAgent"
              (onFieldsUpdated)="handleAgentFieldsChanges($event)"
            ></ag-shr-portal>
          </div>

          <div class="col-6" *ngIf="Entity.agentAgentInfoMga | hasPermission | async">
            <ag-crm-agency-info [agent]="selectedAgent"></ag-crm-agency-info>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12" *ngIf="Entity.agentAgentInfoStatusActivity | hasPermission | async">
            <ag-shr-approve-deny-reasons
              [agent]="selectedAgent"
              [canEdit]="
                Entity.agentAgentInfoStatusActivity | hasPermission: EntityPermissionActivityKeys.write | async
              "
              [canDelete]="
                Entity.agentAgentInfoStatusActivity | hasPermission: EntityPermissionActivityKeys.delete | async
              "
              [canCreate]="
                Entity.agentAgentInfoStatusActivity | hasPermission: EntityPermissionActivityKeys.create | async
              "
            ></ag-shr-approve-deny-reasons>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12" *ngIf="Entity.agentAgentInfoNeedToKnow | hasPermission | async">
            <ag-shr-need-to-know
              [agent]="selectedAgent"
              [sourceType]="sourceType"
              [canEdit]="Entity.agentAgentInfoNeedToKnow | hasPermission: EntityPermissionActivityKeys.write | async"
              [canDelete]="Entity.agentAgentInfoNeedToKnow | hasPermission: EntityPermissionActivityKeys.delete | async"
              [canCreate]="Entity.agentAgentInfoNeedToKnow | hasPermission: EntityPermissionActivityKeys.create | async"
            ></ag-shr-need-to-know>
          </div>
        </div>

        <div class="row mt-2" *ngIf="Entity.agentAgentInfoCarriers | hasPermission | async">
          <div class="col-12">
            <ag-shr-carriers
              [canEdit]="Entity.agentAgentInfoCarriers | hasPermission: EntityPermissionActivityKeys.write | async"
              [canDelete]="Entity.agentAgentInfoCarriers | hasPermission: EntityPermissionActivityKeys.delete | async"
              [canCreate]="Entity.agentAgentInfoCarriers | hasPermission: EntityPermissionActivityKeys.create | async"
              [agent]="selectedAgent"
              [sourceType]="sourceType"
            ></ag-shr-carriers>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-6" *ngIf="Entity.agentAgentInfoDepartmentOfInsuranceInfo | hasPermission | async">
            <ag-crm-doi [agent]="selectedAgent" [sourceType]="sourceType"></ag-crm-doi>
          </div>

          <div class="col-6" *ngIf="Entity.agentAgentInfoStatesLicensedIn | hasPermission | async">
            <ag-shr-licenses
              [agentId]="selectedAgent?.dbId"
              [sourceType]="sourceType"
              [licenses]="selectedAgent?.state_licenses"
              [canEdit]="
                Entity.agentAgentInfoStatesLicensedIn | hasPermission: EntityPermissionActivityKeys.write | async
              "
              [canDelete]="
                Entity.agentAgentInfoStatesLicensedIn | hasPermission: EntityPermissionActivityKeys.delete | async
              "
              [canCreate]="
                Entity.agentAgentInfoStatesLicensedIn | hasPermission: EntityPermissionActivityKeys.create | async
              "
              (licensesChange)="selectedAgent.state_licenses = $event"
            >
            </ag-shr-licenses>
          </div>
        </div>

        <div class="row mt-2">
          <div
            class="col-6"
            *ngIf="selectedAgent[AgentKeys.isActiveCampaigns] && Entity.agentCampaignWizard | hasPermission | async"
          >
            <ag-shr-campaigns
              [agent]="selectedAgent"
              [sourceType]="sourceType"
              [canEdit]="Entity.agentCampaignWizard | hasPermission: EntityPermissionActivityKeys.write | async"
              [canDelete]="Entity.agentCampaignWizard | hasPermission: EntityPermissionActivityKeys.delete | async"
              [canCreate]="Entity.agentCampaignWizard | hasPermission: EntityPermissionActivityKeys.create | async"
              (campaignsChange)="handleAgentFieldsChanges($event)"
            ></ag-shr-campaigns>
          </div>

          <div class="col-6">
            <ag-shr-signed-policies
              [agentDbId]="selectedAgent[BaseModelKeys.dbId]"
              [sourceType]="sourceType"
            ></ag-shr-signed-policies>
          </div>
        </div>
      </dx-scroll-view>
    </ng-template>

    <ng-template [ngIf]="selectedAgentTab === 'Event Info'">
      <dx-scroll-view height="55%">Tab 4</dx-scroll-view>
    </ng-template>

    <ng-template [ngIf]="selectedAgentTab === 'Permissions'">
      <ag-crm-permissions
        [agent]="selectedAgent"
        [sourceType]="sourceType"
        [canEdit]="Entity.agentPermissions | hasPermission: EntityPermissionActivityKeys.write | async"
        [canDelete]="Entity.agentPermissions | hasPermission: EntityPermissionActivityKeys.delete | async"
        [canCreate]="Entity.agentPermissions | hasPermission: EntityPermissionActivityKeys.create | async"
      ></ag-crm-permissions>
    </ng-template>

    <ng-template [ngIf]="selectedAgentTab === 'Alliance Campaigns'">
      <!-- TODO refactor markup to avoid fixed heights -->
      <div [style.height]="'70%'">
        <ag-shr-agent-campaign-wizard
          [withSupportButton]="false"
          [sourceType]="sourceType"
          [canEdit]="Entity.agentCampaignWizard | hasPermission: EntityPermissionActivityKeys.write | async"
          [canDelete]="Entity.agentCampaignWizard | hasPermission: EntityPermissionActivityKeys.delete | async"
          [canCreate]="Entity.agentCampaignWizard | hasPermission: EntityPermissionActivityKeys.create | async"
        ></ag-shr-agent-campaign-wizard>
      </div>
    </ng-template>

    <ng-template [ngIf]="selectedAgentTab === 'Media'">
      <div class="row">
        <div class="col">
          <ag-shr-agent-media
            [agentId]="selectedAgent?.dbId"
            [canEdit]="Entity.agentMedia | hasPermission: EntityPermissionActivityKeys.write | async"
            [canDelete]="Entity.agentMedia | hasPermission: EntityPermissionActivityKeys.delete | async"
            [canCreate]="Entity.agentMedia | hasPermission: EntityPermissionActivityKeys.create | async"
            [sourceType]="sourceType"
          ></ag-shr-agent-media>
        </div>
      </div>
    </ng-template>

    <ng-template [ngIf]="selectedAgentTab === agentChangesHistoryTitle">
      <div class="agent-editor__change-history">
        <ag-shr-changes-history-grid
          #agentChangeHistoryRef
          [changeLogType]="ChangeLogsHistoryType.agent"
          [agent]="selectedAgent"
          [canEdit]="Entity.agentChangesHistory | hasPermission: EntityPermissionActivityKeys.write | async"
          [canDelete]="Entity.agentChangesHistory | hasPermission: EntityPermissionActivityKeys.delete | async"
          [canCreate]="Entity.agentChangesHistory | hasPermission: EntityPermissionActivityKeys.create | async"
        ></ag-shr-changes-history-grid>
      </div>
    </ng-template>
  </ng-template>

  <ng-template [ngIf]="detailsView === 'Prospect'">
    <dx-tabs
      style="width: 100%"
      [dataSource]="prospectTabs"
      [selectedIndex]="0"
      (onItemClick)="selectProspectTab($event)"
    >
    </dx-tabs>
    <ng-template [ngIf]="selectedProspectTab === 'Prospect'">
      <dx-scroll-view height="55%">
        <ag-crm-prospect [agent]="selectedAgent" [prospect]="selectedProspect"></ag-crm-prospect>
      </dx-scroll-view>
    </ng-template>
  </ng-template>

  <div class="row d-flex my-3" style="margin: 0 auto">
    <div class="col-6 text-start">
      <dx-button
        *ngIf="selectedProspect && detailsView === 'Agent'"
        width="200"
        stylingMode="contained"
        text="View Prospect"
        type="default"
        (onClick)="detailsView = 'Prospect'"
      ></dx-button>

      <dx-button
        *ngIf="detailsView === 'Prospect'"
        width="200"
        stylingMode="contained"
        text="View Agent"
        type="default"
        (onClick)="detailsView = 'Agent'"
      ></dx-button>
    </div>
  </div>
</dx-scroll-view>
